import React, { useState, useEffect } from 'react';
import styles from '../../TransferPage.module.scss';
import blocation from 'assets/images/location-black.svg';
import bphone from 'assets/images/phone-black.svg';
import bbranch from 'assets/images/branch-black.svg';
import check from 'assets/images/check-icn.svg';
import { RecentTranscation } from '../../../common/recent-transcation/Recent-Transcation';
import { Transfer } from '../../../common/transfer/Transfer';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import Label from '../../../../constants/Label';
const AmountTransfer = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [buttonActive, setButtonActive] = useState(false);
  const ratecharges = useSelector((state) => state.ratecharges);
  useEffect(() => {
    if (location.state.rateOfTransfer && location.state.rateOfTransfer?.ratecharges == true) {
      setButtonActive(false);
    } else {
      setButtonActive(true);
    }
  }, []);
  const [menu, setMenu] = useState({
    beneficiary: false,
    amount: false,
    payment: false,
    confirm: false,
    transfer: false,
    print: false,
  });

  const backButton = () => {
    setMenu((menu) => (menu, (menu.beneficiary = true), (menu.amount = false)));
    const menuValue = {
      ...location.state,
      menu,
      buttonActive,
    };
    history.push({ pathname: '/transfer', state: menuValue });
  };

  const forwordButton = () => {
    if (location.state.rateOfTransfer && location.state.rateOfTransfer.ratecharges) {
      setButtonActive(false);
    } else {
      setButtonActive(true);
    }
    const menu = {
      beneficiary: false,
      amount: false,
      payment: true,
      confirm: false,
      transfer: false,
      print: false,
    };
    // setMenu((menu) => (menu, (menu.payment = true), (menu.amount = false)));
    const menuValue = {
      ...location.state,
      menu,
      buttonActive,
    };
    history.push({ pathname: '/transfer', state: menuValue });
  };
  return (
    <>
      <div className={styles.amount}>
        <div className={styles.beneficiary__Bitem + ' ' + styles.active}>
          <h3>
            {location.state.items && location.state.items.BenfName}
            <span> #{location.state.items && location.state.items.CustomerCode}</span>
          </h3>
          <p>
            <span>
              <img src={blocation} alt="" />
              {location.state.items && location.state.items.BenfCountry}
            </span>
            <span>
              <img src={bphone} alt="" />
              {location.state.items && location.state.items.BenfMobileNo}
            </span>
          </p>
          <p className={styles.noBorder} style={{ minHeight: '74px', display: 'block' }}>
            <span>
              {location.state.items?.Service === 'BANK TRANSFER' && (
                <>
                  <img src={bbranch} alt="" />
                  {Label.Amount.ACNo}: {location.state.items && location.state.items.AccountNo}
                  {`${location.state.items?.BenfAddr1 ? ', ' : ''}`} {location.state.items?.BenfAddr1}
                </>
              )}
            </span>
            {location.state.items?.Service === 'BANK TRANSFER' && location.state.items?.BenfBank && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{location.state.items?.BenfBank}</span>
              </>
            )}
            {location.state.items?.Service === 'BANK TRANSFER' && location.state.items?.BenfBranch && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{location.state.items?.BenfBranch}</span>
              </>
            )}
            {location.state.items?.Service === 'BANK TRANSFER' && location.state.items?.BicCode && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{location.state.items?.BicCode}</span>
              </>
            )}
          </p>
          <h6>
            <span>
              {Label.Amount.ServiceMode} <span>{location.state.items && location.state.items.Service}</span>
            </span>

            <span>
              <input type="radio" disabled={true} defaultChecked={true} name="color" />
              <label>
                <span>
                  <img src={check} alt="" />
                </span>
              </label>
            </span>
          </h6>
        </div>
        <div className={styles.amount__item}>
          <p className={styles.amount__Pdetail}>
            <span> {Label.Amount.TransferRate}</span>
            <span>
              1.00 KWD = {location.state.rateOfTransfer && location.state.rateOfTransfer.data?.DRate}{' '}
              {location.state.items && location.state.items.CurrencyCode}
              {/* {location.state.rateOfTransfer?.data?.Charge} */}
            </span>
          </p>
          <p className={styles.amount__Pdetail}>
            <span>{Label.Amount.TransferFee}</span>
            <span>{location.state.rateOfTransfer && location.state.rateOfTransfer?.data?.sCharge} KWD</span>
          </p>
          <p className={styles.amount__Pdetail}>
            <span>{Label.Amount.Amountpayable}</span>
            <span>{location.state.rateOfTransfer && location.state.rateOfTransfer?.data?.sNetAmount} KWD</span>
          </p>
        </div>
        <Transfer />
        <RecentTranscation />
      </div>
      <div className={styles.pageLeft__buttonCenter}>
        <Button onClick={backButton}>previous</Button>
        <Button className={buttonActive && location.state.rateOfTransfer?.data == null ? 'disabled' : ''} onClick={forwordButton}>
          {' '}
          next{' '}
        </Button>
      </div>
    </>
  );
};

export default AmountTransfer;
